module.exports = __webpack_public_path__ + "static/media/blog-5.b69dd3dc.jpg";